import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, Space, Typography, Table, Input, Modal, Checkbox, Radio } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faSearch } from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";

const NEW_ADJUSTMENT_CODE_BASE_STATE = { name: "", discount: 1 };

function AdjustmentCodes(props) {
  const [adjustmentCodes, setAdjustmentCodes] = useState([]);
  const [filteredAdjustmentCodes, setFilteredAdjustmentCodes] = useState([]);
  const [searchTerm, setSearchTerm] = useState(null);

  const [selectedAdjustmentCode, setSelectedAdjustmentCode] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [newAdjustmentCode, setNewAdjustmentCode] = useState(NEW_ADJUSTMENT_CODE_BASE_STATE);

  const table_columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <Typography.Title level={5}>{text}</Typography.Title>,
      sorter: (a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1),
      defaultSortOrder: "ascend",
    },

    {
      title: "Adjustment Type",
      dataIndex: "discount",
      key: "discount",
      render: (value) => (value ? "Discount" : "Markup"),
    },
    {
      title: "Actions",
      align: "right",
      dataIndex: "id",
      key: "id",
      render: (text, row) => (
        <Space>
          <Button
            size="small"
            type="primary"
            onClick={() => {
              setEditModalOpen(true);
              setSelectedAdjustmentCode(adjustmentCodes.find((f) => f.id === text));
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="mr-1" />
            Edit
          </Button>
          <Button
            size="small"
            danger
            onClick={() => {
              setDeleteModalOpen(true);
              setSelectedAdjustmentCode(adjustmentCodes.find((f) => f.id === text));
            }}
          >
            <FontAwesomeIcon icon={faTrash} className="mr-1" />
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  const GetAdjustmentCodes = async () => {
    let response = await props.AxiosRequest("/api/adjustment-codes/get");
    setAdjustmentCodes(response.data.adjustment_codes);
    setFilteredAdjustmentCodes(response.data.adjustment_codes);
  };
  const UpdateAdjustmentCode = async () => {
    await props.AxiosRequest("/api/adjustment-codes/update", { ...selectedAdjustmentCode });
    GetAdjustmentCodes();
    setEditModalOpen(false);
    setSelectedAdjustmentCode(null);
  };
  const DeleteAdjustmentCode = async () => {
    await props.AxiosRequest("/api/adjustment-codes/delete", { id: selectedAdjustmentCode.id });
    GetAdjustmentCodes();
    setDeleteModalOpen(false);
    setSelectedAdjustmentCode(null);
  };
  const AddAdjustmentCode = async () => {
    if (newAdjustmentCode.name.length === 0) return props.MakeNotification("info", "Please Enter All Required Fields.");
    await props.AxiosRequest("/api/adjustment-codes/insert", { ...newAdjustmentCode });
    GetAdjustmentCodes();
    setAddModalOpen(false);
    setNewAdjustmentCode(NEW_ADJUSTMENT_CODE_BASE_STATE);
  };

  useEffect(() => {
    GetAdjustmentCodes();
  }, []);

  useEffect(() => {
    if (searchTerm?.length === 0) return setFilteredAdjustmentCodes(adjustmentCodes);
    let filtered_list = adjustmentCodes.filter((f) => (_.toLower(f.name).indexOf(_.toLower(searchTerm)) > -1 ? true : false));
    setFilteredAdjustmentCodes(filtered_list);
  }, [searchTerm]);

  return (
    <main className="content">
      <div className="container-fluid">
        <div className="header">
          <h1 className="header-title">Adjustment Codes</h1>
        </div>
        <Row>
          <Card
            title={<>Adjustment Codes</>}
            style={{
              width: "100%",
            }}
            extra={
              <>
                <Button
                  type="primary"
                  onClick={() => {
                    setNewAdjustmentCode(NEW_ADJUSTMENT_CODE_BASE_STATE);
                    setAddModalOpen(true);
                  }}
                >
                  <FontAwesomeIcon icon="plus" className="me-2" />
                  Add A New Adjustment Code
                </Button>
              </>
            }
          >
            <Row>
              <Col span={18}></Col>
              <Col span={6}>
                <Input
                  className="mb-2"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                  placeholder="Search..."
                  allowClear
                />
              </Col>
            </Row>
            <Table className="table table-striped hover" columns={table_columns} dataSource={filteredAdjustmentCodes} />
          </Card>
        </Row>
        <Modal
          title="Edit Adjustment Code"
          centered
          open={editModalOpen}
          onCancel={() => {
            setEditModalOpen(false);
            setSelectedAdjustmentCode(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setEditModalOpen(false);
                  setSelectedAdjustmentCode(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  UpdateAdjustmentCode();
                }}
              >
                Save Changes
              </Button>
            </>
          }
        >
          {selectedAdjustmentCode ? (
            <>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col span={24}>
                  <label className="col-form-label-sm">Adjustment Code Name *</label>
                  <Input
                    value={selectedAdjustmentCode.name}
                    onChange={(e) => {
                      setSelectedAdjustmentCode({ ...selectedAdjustmentCode, name: e.target.value });
                    }}
                  />
                </Col>
                <Col span={24}>
                  <label className="col-form-label-sm">Adjustment Type *</label>
                  <br />
                  <Radio.Group
                    onChange={(e) => {
                      setSelectedAdjustmentCode({ ...selectedAdjustmentCode, discount: e.target.value });
                    }}
                    value={selectedAdjustmentCode.discount}
                  >
                    <Radio value={1}>Discount</Radio>
                    <Radio value={0}>Markup</Radio>
                  </Radio.Group>
                </Col>
              </Row>
            </>
          ) : null}
        </Modal>

        <Modal
          title={"Are you sure?"}
          centered
          open={deleteModalOpen}
          onCancel={() => {
            setDeleteModalOpen(false);
            setSelectedAdjustmentCode(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setDeleteModalOpen(false);
                  setSelectedAdjustmentCode(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                danger
                onClick={() => {
                  DeleteAdjustmentCode();
                }}
              >
                Delete
              </Button>
            </>
          }
        >
          {selectedAdjustmentCode ? <>Are you sure you want to delete the adjustment code {selectedAdjustmentCode?.name}?</> : null}
        </Modal>

        <Modal
          title={"Add A New Adjustment Code"}
          centered
          open={addModalOpen}
          onCancel={() => {
            setAddModalOpen(false);
            setSelectedAdjustmentCode(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setAddModalOpen(false);
                  setSelectedAdjustmentCode(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  AddAdjustmentCode();
                }}
              >
                Add
              </Button>
            </>
          }
        >
          {newAdjustmentCode ? (
            <>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col span={24}>
                  <label className="col-form-label-sm">Adjustment Code Name *</label>
                  <Input
                    value={newAdjustmentCode.name}
                    onChange={(e) => {
                      setNewAdjustmentCode({ ...newAdjustmentCode, name: e.target.value });
                    }}
                  />
                </Col>
                <Col span={24}>
                  <label className="col-form-label-sm">Adjustment Type *</label>
                  <br />
                  <Radio.Group
                    onChange={(e) => {
                      setNewAdjustmentCode({ ...newAdjustmentCode, discount: e.target.value });
                    }}
                    value={newAdjustmentCode.discount}
                  >
                    <Radio value={1}>Discount</Radio>
                    <Radio value={0}>Markup</Radio>
                  </Radio.Group>
                </Col>
              </Row>
            </>
          ) : null}
        </Modal>
      </div>
    </main>
  );
}

export default AdjustmentCodes;
